<template>
	<div class="container">
		<div class="content">
			<div class="card mh_700 mb_0">
				<h3 class="title mb_20">{{ $t('cs.inquiry.list') }}</h3>
				<div class="q_list">
					<table>
						<colgroup>
							<col style="width: 50px" />
							<col style="width: 110px" />
							<col style="width: 530px" />
							<col style="width: 120px" />
							<!--							<col style="width: 170px" />-->
						</colgroup>
						<thead>
							<tr>
								<th>No</th>
								<th>{{ $t('cs.inquiry.type') }}</th>
								<th>{{ $t('cs.inquiry.title') }}</th>
								<th>{{ $t('cs.inquiry.date') }}</th>
								<th>{{ $t('cs.inquiry.status') }}</th>
							</tr>
						</thead>
						<tbody v-if="inquiryList.length > 0">
							<tr
								v-for="item in inquiryList"
								:key="item.seq"
								@click="toDetail(item.seq)"
							>
								<td>
									{{ item._no }}
								</td>
								<td>{{ item.type_title }}</td>
								<td>{{ item.title }}</td>
								<td>{{ $dayjs(item.regdate).format('YYYY.MM.DD') }}</td>
								<td v-if="item.status === 'PENDING'">
									<span class="pending">{{ $t('cs.inquiry.pending') }}</span>
								</td>
								<td v-else>
									<span class="close">{{ $t('cs.inquiry.complete') }}</span>
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td colspan="5">
									{{ $t('cs.inquiry.no_content') }}
								</td>
							</tr>
						</tbody>
					</table>
					<pagination
						:totalCount="pageNavigation.total_count"
						:totalPage="pageNavigation.total_page"
						:curPage="pageNavigation.cur_page"
						:point="pageNavigation.point"
						:firstPage="pageNavigation.first_page"
						:lastPage="pageNavigation.last_page"
						@change="pageChangeHandler"
					></pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import pagination from '@/components/Pagination';
import { fetchTicketList } from '@/api/cs';
import { commonError } from '@/common/dialog';
export default {
	name: 'InquiryList',
	components: {
		pagination,
	},
	data() {
		return {
			inquiryList: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 12,
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadInquiryList();
		},
		async loadInquiryList() {
			const params = {
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchTicketList(params).catch(
				commonError,
			);
			this.inquiryList = data;
			this.pageNavigation = page_navigation;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadInquiryList();
		},
		toDetail(seq) {
			this.$router.push({
				name: 'user-inquiry-detail',
				query: { ticket_seq: seq },
			});
		},
	},
};
</script>
